import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import {unregister} from './registerServiceWorker';
import packageJson from '../package.json';
import { getEnvironmentVariables } from './services/appServices/appService';



// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const baseUrl = window.location.origin;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
export const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

//fetch the public file 
var headers = new Headers();
headers.append('pragma', 'no-cache');
headers.append('cache-control', 'no-cache');

var fetchConfig = {
  method: 'GET',
  headers
};

let url = './releasevariables.json';
fetch(url, fetchConfig)
.then(res => res.json())
.then(variables => {
  console.log('Release Variables', variables);
  console.log('Package Build Number', packageJson.buildNumber);
  if(variables && variables.buildNumber && variables.buildNumber !== packageJson.buildNumber){
    console.log('Hard reloading because browser does not have latest version');
     //window.location.reload(true); //this function has been depricated
     window.location.href = `${window.location.href}?clearcache=true`;
  }
  else{
    console.log('Browser have latest code');
    getEnvironmentVariables().then((res) => {
      ReactDOM.render(
        <Provider store={store}>
              <App history={history} environment={res.data} />
        </Provider>,
        rootElement);
    })
    .catch((err) => {
      console.log(
        "Error occured while setting the environment variables",
        err
      );
    })
  }
})
.catch(err => {
  alert("Failed to pull release variables");
})



//registerServiceWorker();
unregister();
